import { ROLES } from '../context/UserRoleContext';

/**
 * FULLSTENDIG MENYSTRUKTUR FOR HMS INNSIKT
 * Gruppert etter funksjonalitet og styrt av brukerroller.
 */

export const navigationGroups = [
  {
    id: 'innsikt',
    label: 'Analyse & Innsikt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER]
  },
  {
    id: 'operativt',
    label: 'Operative Verktøy',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER, ROLES.EMPLOYEE]
  },
  {
    id: 'portefolje',
    label: 'Kunde & Prosjekt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN]
  },
  {
    id: 'admin',
    label: 'System & Admin',
    roles: [ROLES.SUPERADMIN, ROLES.COMPANY_ADMIN]
  }
];

export const navigationConfig = [
  // --- DASHBOARD ---
  {
    name: 'Dashboard',
    icon: 'Layout',
    path: '/dashboard/main',
    groupId: 'innsikt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER, ROLES.EMPLOYEE],
    subItems: [
      { name: 'Oversikt', path: '/dashboard/customer' },
      { name: 'WE Scores', path: '/dashboard/work-environment-score' },
      { name: 'Org. Helse', path: '/dashboard/org-health' },
      { name: 'Heatmap', path: '/dashboard/heatmap' },
      { name: 'Varsler', path: '/dashboard/alerts', badge: '2' },
      { name: 'Trender', path: '/dashboard/strategic' },
      { name: 'Benchmark', path: '/dashboard/benchmark' }
    ]
  },

  // --- ASSESSMENTS ---
  {
    name: 'Kartlegging',
    icon: 'Clipboard',
    path: '/dashboard/assessments',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.EMPLOYEE],
    subItems: [
      { name: 'Alle målinger', path: '/dashboard/assessments' },
      { name: 'Ny kartlegging', path: '/take-assessment' },
      { name: 'Maler', path: '/dashboard/assessments?view=templates' },
      { name: 'Resultater', path: '/dashboard/diagnosis' },
      { name: 'Avdelings-sammenligning', path: '/dashboard/dept-risk' },
      { name: 'Invitasjoner', path: '/dashboard/assessments?view=invites' }
    ]
  },

  // --- WORKSHOPS ---
  {
    name: 'Workshops',
    icon: 'Users',
    path: '/dashboard/workshops',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.EMPLOYEE],
    subItems: [
      { name: 'Bibliotek', path: '/dashboard/workshops' },
      { name: 'Planlagte', path: '/dashboard/workshops/planned' },
      { name: 'Opprett ny', path: '/dashboard/facilitator' },
      { name: 'AI Agenda', path: '/dashboard/agenda-generator' },
      { name: 'Fasilitator-verktøy', path: '/dashboard/facilitator/tools' },
      { name: 'Rapporter', path: '/dashboard/workshops/reports' }
    ]
  },

  // --- REPORTS ---
  {
    name: 'Rapporter',
    icon: 'FileText',
    path: '/dashboard/reports',
    groupId: 'innsikt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER],
    subItems: [
      { name: 'Alle rapporter', path: '/dashboard/reports' },
      { name: 'WE Rapport', path: '/dashboard/reports?type=we' },
      { name: 'Styreoppsummering', path: '/dashboard/board-presentation' },
      { name: 'Avdelingsrapporter', path: '/dashboard/reports?type=department' },
      { name: 'Lederrapporter', path: '/dashboard/reports?type=leader' },
      { name: 'Compliance-rapporter', path: '/dashboard/compliance' }
    ]
  },

  // --- CLIENTS ---
  {
    name: 'Kunder',
    icon: 'Briefcase',
    path: '/dashboard/health',
    groupId: 'portefolje',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT],
    subItems: [
      { name: 'Kundeoversikt', path: '/dashboard/health' },
      { name: 'Kundeprofiler', path: '/dashboard/clients/profiles' },
      { name: 'Kontakter', path: '/dashboard/clients/contacts' },
      { name: 'Risiko-oversikt', path: '/dashboard/dept-risk' },
      { name: 'Dokumenter', path: '/dashboard/clients/docs' }
    ]
  },

  // --- PROJECTS ---
  {
    name: 'Prosjekter',
    icon: 'Folder',
    path: '/dashboard/projects',
    groupId: 'portefolje',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN],
    subItems: [
      { name: 'Alle prosjekter', path: '/dashboard/projects' },
      { name: 'Nytt prosjekt', path: '/dashboard/projects/new' },
      { name: 'Tidslinje', path: '/dashboard/projects/timeline' },
      { name: 'Status', path: '/dashboard/projects/status' },
      { name: 'Leveranser', path: '/dashboard/projects/deliverables' },
      { name: 'Notater', path: '/dashboard/projects/notes' }
    ]
  },

  // --- ACTION PLANS ---
  {
    name: 'Handlingsplaner',
    icon: 'Target',
    path: '/dashboard/dept-plan',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER],
    subItems: [
      { name: 'Alle planer', path: '/dashboard/dept-plan' },
      { name: '90-dagers plan', path: '/dashboard/90-day-plan' },
      { name: 'Avdelingsplaner', path: '/dashboard/dept-plan/internal' },
      { name: 'Lederplaner', path: '/dashboard/leader-actions' },
      { name: 'Oppfølgings-hjul', path: '/dashboard/plan/schedule' }
    ]
  },

  // --- LEADER TOOLS ---
  {
    name: 'Lederverktøy',
    icon: 'Zap',
    path: '/dashboard/leader',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.DEPARTMENT_LEADER],
    subItems: [
      { name: 'Lederdashboard', path: '/dashboard/leader' },
      { name: 'Min avdeling', path: '/dashboard/twin' },
      { name: 'Mine skårer', path: '/dashboard/leader/scores' },
      { name: 'Mine tiltak', path: '/dashboard/leader-actions' },
      { name: 'AI Leder-Coach', path: '/dashboard/coach' },
      { name: 'Team Fokus', path: '/dashboard/leader/focus' }
    ]
  },

  // --- COURSES ---
  {
    name: 'Kurs',
    icon: 'BookOpen',
    path: '/dashboard/courses',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER, ROLES.EMPLOYEE],
    subItems: [
      { name: 'Kursbibliotek', path: '/dashboard/courses' },
      { name: 'Mine tildelte', path: '/dashboard/courses/assigned' },
      { name: 'Fullførte', path: '/dashboard/courses/completed' },
      { name: 'Sertifikater', path: '/dashboard/courses/certs' }
    ]
  },
  {
    name: 'Academy Admin',
    icon: 'BookOpen',
    path: '/dashboard/academy-admin',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.COMPANY_ADMIN],
    subItems: [
      { name: 'Administrasjon', path: '/dashboard/academy-admin' },
      { name: 'Kursdeltakere', path: '/dashboard/academy-admin/participants' }
    ]
  },

  // --- COMPLIANCE ---
  {
    name: 'Compliance',
    icon: 'ShieldCheck',
    path: '/dashboard/compliance',
    groupId: 'admin',
    roles: [ROLES.SUPERADMIN, ROLES.COMPANY_ADMIN],
    subItems: [
      { name: 'Oversikt', path: '/dashboard/compliance' },
      { name: 'Lovverksmating', path: '/dashboard/nordic-standard' },
      { name: 'Dokumentasjonslogg', path: '/dashboard/compliance/log' },
      { name: 'Tiltaksdokumentasjon', path: '/dashboard/compliance/actions' },
      { name: 'Revisjonsvisning', path: '/dashboard/compliance/audit' }
    ]
  },

  // --- INDUSTRY PROFILES ---
  {
    name: 'Bransjeprofiler',
    icon: 'Briefcase',
    path: '/dashboard/industry-profiles',
    groupId: 'admin',
    roles: [ROLES.SUPERADMIN]
  },

  // --- BOOKING ---
  {
    name: 'Booking',
    icon: 'Calendar',
    path: '/dashboard/booking',
    groupId: 'operativt',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT, ROLES.COMPANY_ADMIN, ROLES.DEPARTMENT_LEADER],
    subItems: [
      { name: 'Rådgivning', path: '/dashboard/booking/consult' },
      { name: 'Workshop', path: '/dashboard/booking/workshop' },
      { name: 'Lederstøtte', path: '/dashboard/booking/support' },
      { name: 'Mekling', path: '/dashboard/booking/mediation' },
      { name: 'Kalender', path: '/dashboard/booking/calendar' }
    ]
  },

  // --- WEBSITE ---
  {
    name: 'Nettside',
    icon: 'Globe',
    path: '/',
    groupId: 'admin',
    roles: [ROLES.SUPERADMIN, ROLES.CONSULTANT],
    subItems: [
      { name: 'Hjem', path: '/' },
      { name: 'Tjenester', path: '/tjenester' },
      { name: 'For Ledere', path: '/om-oss' },
      { name: 'Booking-side', path: '/booking' },
      { name: 'Kontakt', path: '/kontakt' },
      { name: 'SEO Sider', path: '/seo' }
    ]
  },

  // --- SETTINGS ---
  {
    name: 'Innstillinger',
    icon: 'Settings',
    path: '/dashboard/settings',
    groupId: 'admin',
    roles: [ROLES.SUPERADMIN, ROLES.COMPANY_ADMIN],
    subItems: [
      { name: 'Min profil', path: '/dashboard/settings/profile' },
      { name: 'Organisasjon', path: '/dashboard/settings/org' },
      { name: 'Branding', path: '/dashboard/settings/branding' },
      { name: 'Brukere', path: '/dashboard/settings/users' },
      { name: 'Rettigheter', path: '/dashboard/settings/permissions' },
      { name: 'Varslinger', path: '/dashboard/settings/notifications' },
      { name: 'Integrasjoner', path: '/dashboard/settings/integrations' }
    ]
  }
];